import { useDispatch, useStore } from 'react-redux';
import { onboardConnectionManager } from 'src/helper/HubConnectionManager';
import { getDeviceConnectionGroups, getDeviceInfo } from '../common/deviceUtils';
import { useEffect, useRef } from 'react';
import useCurrentUserId from 'src/helper/useCurrentUserId';
import useDockKeepAliveOvserver from './useDockKeepAliveObserver';
import { onboardWaypointAction } from 'src/services/mission/common/missionConstants';
import useDeviceFlightAuthority from '../common/useDeviceFlightAuthority';

function usePsdkDeviceObserver() {
  const messageHandlerIds = useRef([]);
  const permanentIntervalId = useRef(null);
  const store = useStore();
  const dispatch = useDispatch();
  const deviceAuthority = useDeviceFlightAuthority();
  const userId = useCurrentUserId();

  useEffect(() => {
    messageHandlerIds.current = onboardConnectionManager.subscribeGroupMessages([
      {
        identity: 'onboardDeviceState/*',
        name: ['onDemandChannel'],
        handler: (message, meta) => {
          const deviceId = meta?.fromUserId?.split('_')[0];
          const deviceInfo = getDeviceInfo(deviceId);
          const connection = getDeviceConnectionGroups(deviceId);
          const data = message.data;
  
          if(message.actionId === onboardWaypointAction.MISSION_QUERY) {
            // auto request PSDK authority if the device is not in PSDK mode on initial mission query
            if(deviceInfo?.details?.turnOnTimestamp && Date.now() - deviceInfo.details.turnOnTimestamp < 120000) {
              setTimeout(() => {
                deviceAuthority?.requestPsdkAuthority(deviceId);
              }, 10000);
            }
          }
        }
      },
    ], 'onboard-device-observer');

    // check device info every 1 second
    permanentIntervalId.current = setInterval(() => {
      // nothing yet
    }, 1000);

    return () => {
      onboardConnectionManager.unsubscribeGroupMessages(messageHandlerIds.current);
      clearInterval(permanentIntervalId.current);
    }
  }, []);

  return true;
}

export default usePsdkDeviceObserver;